// app/layout.tsx
"use client";
import { ReactQueryProvider } from "./providers/ReactQueryProvider";
import "./globals.css";
import { ZustandProvider } from "./providers/ZustandProvider";
import { OpenAPIProvider } from "./providers/OpenAPIProvider";
import { GoogleTagManager } from "@next/third-parties/google";
import { usePathname } from "next/navigation";

function ConditionalGTM() {
  const pathname = usePathname();

  // Don't render GTM in preview mode
  if (pathname?.startsWith("/preview")) {
    return null;
  }

  return <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID || ""} />;
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <head>
        <link
          rel="icon"
          href="/icons/favicon.png"
          type="image/png"
          sizes="any"
        />
      </head>
      <ConditionalGTM />
      <body suppressHydrationWarning>
        <OpenAPIProvider>
          <ReactQueryProvider>
            <ZustandProvider>{children}</ZustandProvider>
          </ReactQueryProvider>
        </OpenAPIProvider>
      </body>
    </html>
  );
}
